export default __webpack_public_path__ + "locales/lv/InviteDialog.json?hash=21f7548c67a01ffca613d0f081be685b";